<template>
  <div class="app-dashboard">
    <div class="row">
      <div class="col-md-2">
        <b-card
          class="height-cards"
          title="Banks"
        >
          <b-card-text>
            {{ totalCounts.banks }}
          </b-card-text>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          class="height-cards"
          title="Events"
        >
          <b-card-text>
            {{ totalCounts.events }}
          </b-card-text>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          class="height-cards"
          title="Members"
        >
          <b-card-text>
            {{ totalCounts.members }}
          </b-card-text>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          class="height-cards"
          title="Transactions"
        >
          <b-card-text>
            {{ totalCounts.transactions }}
          </b-card-text>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          class="height-cards"
          title="Transaction Types"
        >
          <b-card-text>
            {{ totalCounts.transactionTypes }}
          </b-card-text>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          class="height-cards"
          title="Unions"
        >
          <b-card-text>
            {{ totalCounts.unions }}
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'
import { appDashboardCounts } from '@/@core/services/groups'
import { hideLoader, showLoader } from '@/@core/comp-functions/ui/app'

export default {
  components: {
    BCard,
    BCardText,
  },
  data() {
    return {
      totalCounts: {
        banks: 0,
        events: 0,
        members: 0,
        transactions: 0,
        transactionTypes: 0,
        unions: 0,
      },
    }
  },
  mounted() {
    this.getDashboardCounts()
  },
  methods: {
    initCounter(totalCount, name) {
      if (!this.tempCounter) {
        this.tempCounter = {}
      }
      const random = Math.ceil(Math.random() * 25)
      this.tempCounter[name] = setInterval(() => {
        // eslint-disable-next-line eqeqeq
        if (this.totalCounts[name] > totalCount) {
          this.totalCounts[name] = totalCount
        }
        // eslint-disable-next-line eqeqeq
        if (this.totalCounts[name] != totalCount) {
          this.totalCounts[name] += random
        } else {
          console.log(`${name} cleared`)
          clearInterval(this.tempCounter[name])
        }
      })
    },
    getDashboardCounts() {
      showLoader()
      appDashboardCounts().then(({ data }) => {
        if (data.succeeded) {
          const payload = data.data
          this.totalCounts = payload
          // this.initCounter(payload.banks, 'banks')
          // this.initCounter(payload.events, 'events')
          // this.initCounter(
          //   payload.members,

          //   'members',
          // )
          // this.initCounter(
          //   payload.transactions,

          //   'transactions',
          // )
          // this.initCounter(
          //   payload.transactionTypes,

          //   'transactionTypes',
          // )
          // this.initCounter(payload.unions, 'unions')
        }
        hideLoader()
      })
    },
  },
}
</script>

<style scoped>
.height-cards {
  height: 85%;
}

.height-cards p {
  font-size: 20px;
}
</style>
